import React, { Fragment, useEffect, useState } from 'react';
import MCQOption from './MCQOption';
import { ALPHABET } from 'legacy/src/utility/utils';
import get from 'lodash/get';

const MCQOptions = ({
  distractors,
  options,
  correctIndexes,
  chooseResponseIndex = () => {},
  studentResponsesForItem = null,
  responseAnalysis = {},
  assignmentReport,
  students,
  studentUrl,
  studentId,
  showPerformance,
  isMultipleResponse,
  showAnalysis,
  currentItem,
  isMathJaxEnabled,
  announceOptions = true,
}) => {
  const { sessions, questions } = responseAnalysis;
  const [activeOption, setActiveOption] = useState(null);

  //set initial selection to correct answer if nothing chosen by student
  useEffect(() => {
    let setCorrectOptionActive = true;
    if (studentId) {
      const chosenByStudent = getChosenByStudent();
      if (chosenByStudent !== -1) {
        setCorrectOptionActive = false;
      }
    }
    if (
      activeOption === null &&
      correctIndexes.length &&
      setCorrectOptionActive
    ) {
      setActiveOption(correctIndexes[0]);
    }
  }, [correctIndexes]);

  //change parent component's selected option for distractor to work
  useEffect(() => {
    chooseResponseIndex(activeOption);
  }, [activeOption]);

  useEffect(() => {
    if (studentId) {
      const chosenByStudent = getChosenByStudent();
      setActiveOption(chosenByStudent !== -1 ? chosenByStudent : null);
    }
  }, [options]);

  const getOptionUsers = (optionValue) => {
    if (responseAnalysis && responseAnalysis.questions) {
      const currentQuestion = questions[0];

      const permutations =
        currentQuestion &&
        currentQuestion.permutations.map((permutation) =>
          get(permutation, 'response.value'),
        );
      const sessionResponses = Object.values(sessions).map((session) => ({
        responses: session.responses.questions,
        user: session.user_id,
      }));

      const optionUsers = [];
      sessionResponses.forEach((sessionResponse) => {
        const currentQuestionResponse =
          currentQuestion &&
          sessionResponse.responses.find(
            (response) => response.question_id === currentQuestion.question_id,
          );
        const responseValue = currentQuestionResponse
          ? permutations[currentQuestionResponse.permutation_idx]
          : null;
        responseValue &&
          responseValue.includes(optionValue) &&
          optionUsers.push(sessionResponse.user);
      });
      // because of Pre-AP and assessment group magic, there can be a user put into the optionUsers array multiple
      // times, so we clean that up in this last step by using .reduce to create a unique array.
      return optionUsers.reduce((result, item) => {
        if (result.indexOf(item) === -1) result.push(item);
        return result;
      }, []);
    }
    return [];
  };

  const getChosenByStudent = () =>
    options.findIndex((option) =>
      (studentResponsesForItem
        ? getOptionUsersWorkaround(option.value)
        : getOptionUsers(option.value)
      ).includes(studentId),
    );

  const getOptionUsersWorkaround = (value) =>
    Object.keys(studentResponsesForItem).reduce((result, current) => {
      const resultsPerStudent = studentResponsesForItem[current];
      if (resultsPerStudent.includes(value)) {
        result.push(current);
      }
      return result;
    }, []);

  const getChosen = (option) => {
    const optionUsers = studentResponsesForItem
      ? getOptionUsersWorkaround(option.value)
      : getOptionUsers(option.value);

    const isChosen = optionUsers.includes(studentId);
    return { optionUsers, isChosen };
  };

  return (
    <Fragment>
      {options.map((option, index) => (
        <MCQOption
          key={option.ariaLabel + index}
          text={option.text}
          ariaLabelText={option.ariaLabel}
          letter={ALPHABET[index]}
          rationale={distractors[index]}
          {...getChosen(option)}
          isCorrect={correctIndexes.includes(index)}
          isActive={index === activeOption}
          setActive={() => setActiveOption(index)}
          assignmentReport={assignmentReport}
          students={students}
          studentUrl={studentUrl}
          showPerformance={showPerformance}
          isMultipleResponse={isMultipleResponse}
          showAnalysis={showAnalysis}
          itemId={currentItem.reference}
          announceOptions={announceOptions}
          isMathJaxEnabled={isMathJaxEnabled}
        />
      ))}
    </Fragment>
  );
};

export default MCQOptions;
